export class TamanhoPapel {

  static Papel58mm = new TamanhoPapel(35);
  static Papel58mm32car = new TamanhoPapel(31);
  static Papel80mm = new TamanhoPapel(48);
  static Papel80mm42car = new TamanhoPapel(42);

  public tamanhoLinha: number;
  public tamanhoLinhaPequeno: number;
  public quebraLinha: string;
  public linhaborda  = ""

  constructor(tamanhoLinha: number) {
    this.tamanhoLinha = tamanhoLinha;
    this.tamanhoLinhaPequeno = tamanhoLinha + 14
    for(let i = 0; i < this.tamanhoLinha; i++)
      this.linhaborda  += '-'
    this.quebraLinha = '\n'
  }
}
